import { isMaliciousUrl } from './../link/is-malicious-url';
import { normalizeHref } from './../link/normalize-href';

import { getBasedUrl } from './get-based-url';
import { isPageUrl } from './is-page-url';

export const getHrefUrl = (url: string, baseUrl?: string): string | undefined =>
  typeof url !== 'string'
    ? undefined
    : isMaliciousUrl(url)
    ? undefined
    : isPageUrl(url)
    ? getBasedUrl(url, baseUrl || '')
    : normalizeHref(url);
